import merge from "lodash.merge";

import { Operation } from "../../components/Car/types";
import { Estimate } from "../../types/Estimate";
import { DeepPartial } from "./deepPartial";

const estimateDefaults = (): Partial<Estimate> => ({
  totalExcludingTax: "£3364.42",
  totalIncludingTax: "£4037.30",
  breakdown: {
    partsTotal: "£1424.73",
    labourTotal: "£436.80",
    paintTotal: "£942.15",
    deductible: "£150.00",
  },
  damagedParts: {
    FBUMPER: {
      operation: Operation.REPLACE,
      replacementPartCost: "£151.00"
    },
    GRILLE: {
      operation: Operation.PAINT,
      replacementPartCost: null
    },
    LHEADLAMP: {
      operation:Operation.REPLACE,
      replacementPartCost: "£722.23"
    },
    BONNET: {
      operation:Operation.REPAIR,
      replacementPartCost: "£563.45"
    },
    FLWING: { operation:Operation.REPLACE },
    FLDOOR: { operation:Operation.BLEND },
  },
  isEstimateDisplayEnabled: true,
  isInScope: true,
  isTotalLoss: false,
  isSpeedyPaymentEnabled: true,
  hasInternalDamage: false,
});

export const generateTestEstimate = (overrides?: DeepPartial<Estimate>): Estimate =>
  merge({}, estimateDefaults() as Estimate, overrides);
